/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./CreditUnionSearch.module.css";

interface RadioOptionProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  name: string;
}

const RadioOption: React.FC<RadioOptionProps> = ({
  id,
  label,
  checked,
  onChange,
  value,
  name,
}) => {
  return (
    <div className={styles.radioOption}>
      <div className={styles.radioButton}>
        <div className={styles.radioContainer}>
          <div className={styles.radioStateLayer}>
            <input
              type="radio"
              id={id}
              checked={checked}
              onChange={onChange}
              className={styles["visually-hidden"]}
              value={value}
              name={name}
            />
            <label htmlFor={id}>
              <img
                loading="lazy"
                src={
                  checked
                    ? "https://cdn.builder.io/api/v1/image/assets/TEMP/b682bd26c360d8a7d257c75040cfcb20674340ec34145fe196cc267082aaa4a7?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
                    : "https://cdn.builder.io/api/v1/image/assets/TEMP/e9930b9a7461ff74138dedb1adb64c91d2d08386894c5db0fc5e5c01971d8b28?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9"
                }
                alt=""
                className={styles.radioIcon}
              />
            </label>
          </div>
        </div>
      </div>
      <label htmlFor={id} className={styles.radioLabel}>
        {label}
      </label>
    </div>
  );
};

export default RadioOption;
